// extracted by mini-css-extract-plugin
export default {"wrapper":"CardWrapper_wrapper__GUeNe"};